import type { DocCategory } from '../registry';
import SearchBestPractices, { toc as searchBestPracticesToc } from '../pages/guides/search-best-practices';
import FindAndNamePeople, { toc as findAndNamePeopleToc } from '../pages/guides/find-and-name-people';
import BuildARoughCut, { toc as buildARoughCutToc } from '../pages/guides/build-a-rough-cut';
import AgenticEditingQuickstart, { toc as agenticEditingQuickstartToc } from '../pages/guides/agentic-editing-quickstart';
import FixSpeechProblems, { toc as fixSpeechProblemsToc } from '../pages/guides/fix-speech-problems';
import Uninstall, { toc as uninstallToc } from '../pages/guides/uninstall';

export const guides: DocCategory = {
  id: 'guides',
  label: 'Guides',
  pages: [
    {
      slug: 'guides/search-best-practices',
      title: 'Get better search results',
      eyebrow: 'Guides',
      description: 'How to phrase queries across Visuals, Speech, and Ultra — and when to use which.',
      toc: searchBestPracticesToc,
      Body: SearchBestPractices,
      related: [
        { label: 'Visual search', to: '/docs/concepts/visual-search' },
        { label: 'Ultra Search', to: '/docs/concepts/ultra-search' },
        { label: 'Search tab', to: '/docs/interface/search' },
      ],
    },
    {
      slug: 'guides/find-and-name-people',
      title: 'Find & name people',
      eyebrow: 'Guides',
      description: 'Run face analysis, name a cluster once, and search by that person everywhere.',
      toc: findAndNamePeopleToc,
      Body: FindAndNamePeople,
      related: [
        { label: 'People & faces', to: '/docs/concepts/people-and-faces' },
        { label: 'People tab', to: '/docs/interface/people' },
      ],
    },
    {
      slug: 'guides/build-a-rough-cut',
      title: 'From search results to a rough cut',
      eyebrow: 'Guides',
      description: 'Turn selected results into a timeline — export from the app, or place clips live in the panel.',
      toc: buildARoughCutToc,
      Body: BuildARoughCut,
      related: [
        { label: 'The Adobe Premiere Pro panel', to: '/docs/platforms/premiere-panel' },
        { label: 'The desktop app', to: '/docs/platforms/standalone-app' },
        { label: 'Search tab', to: '/docs/interface/search' },
      ],
    },
    {
      slug: 'guides/agentic-editing-quickstart',
      title: 'Your first agentic edit',
      eyebrow: 'Guides',
      description: 'Connect an AI agent to ClipRadar and have it search and build a timeline for you.',
      toc: agenticEditingQuickstartToc,
      Body: AgenticEditingQuickstart,
      related: [
        { label: 'Agentic editing (MCP)', to: '/docs/concepts/agentic-editing' },
        { label: 'MCP tool reference', to: '/docs/reference/mcp-tools' },
        { label: 'Settings tab', to: '/docs/interface/settings' },
      ],
    },
    {
      slug: 'guides/fix-speech-problems',
      title: 'Fix speech & transcript problems',
      eyebrow: 'Guides',
      description: "When a file's audio won't transcribe — read the badge, re-transcribe, or repair the copy.",
      toc: fixSpeechProblemsToc,
      Body: FixSpeechProblems,
      related: [
        { label: 'Speech search', to: '/docs/concepts/speech-search' },
        { label: 'Media tab', to: '/docs/interface/media' },
        { label: 'Analysis, missing files & speech problems', to: '/docs/troubleshooting/analysis-and-files' },
      ],
    },
    {
      slug: 'guides/uninstall',
      title: 'Uninstall ClipRadar',
      eyebrow: 'Guides',
      description: 'Remove ClipRadar cleanly on Windows — and optionally its data, models, and the panel.',
      toc: uninstallToc,
      Body: Uninstall,
      related: [
        { label: 'Where ClipRadar stores things', to: '/docs/reference/where-your-data-lives' },
        { label: 'The Adobe Premiere Pro panel', to: '/docs/platforms/premiere-panel' },
      ],
    },
  ],
};
